import * as Yup from 'yup';

const personalInfoSchema = (phoneFormat, blockedNumber) => {
    // Remove all non-digit and non-plus characters from the format (e.g., "+44 799 999 9999" -> "+447999999999")
    const normalizedFormat = phoneFormat?.replace(/\s+/g, '') || '';

    return Yup.object().shape({
        ftm_street_address: Yup.string().required('Street address is required'),
        ftm_place: Yup.string().required('City is required'),
        ftm_postcode: Yup.string().required('Postcode is required'),
        ftm_driving_license_number: Yup.string().required('Driving licence number is required'),
        ftm_vehicle_brand: Yup.string().required('Vehicle brand is required'),
        ftm_vehicle_model: Yup.string().required('Vehicle model is required'),
        ftm_vehicle_color: Yup.string().required('Vehicle color is required'),
        ftm_next_of_kin: Yup.string().required('Emergency contact is required'),
        ftm_utr_number: Yup.string().required('Personal UTR number is required'),
        ftm_ni_number: Yup.string().required('NI number is required'),
        ftm_bank_name: Yup.string().required('Bank name is required'),
        ftm_bank_sort_code: Yup.string()
            .required('Bank sort code is required')
            .matches(/^\d{2}-\d{2}-\d{2}$/, 'Bank sort code must be in the format XX-XX-XX'),
        ftm_bank_account_number: Yup.string()
            .required('Bank account number is required')
            .matches(/^\d{4}-\d{4}$/, 'Bank account number must be in the format XXXX-XXXX'),
        ftm_vehicle_number: Yup.string()
            .required('Vehicle registration is required'),
        // .matches(/^[A-Z]{2}\d{2}\s[A-Z]{3}$/, 'Vehicle registration must be in the format AB12 XYZ'),
        ftm_next_of_kin_contact_number: Yup.string()
            .transform(value => value.replace(/\s+/g, '')) // Normalize value
            .required('Phone number is required')
            .matches(/^\+447\d{2}\d{3}\d{4}$/, `Emergency contact phone number must be in the format ${normalizedFormat}`)
            .notOneOf([blockedNumber], 'This phone number is not allowed'),
    });
};

export default personalInfoSchema;